import { Card, CardLink } from '@/types/card';
import { CardLinkFormValues } from '@/types/cardLink';
import { Query } from '@/types/query';
import { PaginatedResponse, Response } from '@/types/response';
import { api } from '@/utils/axios';

export const ShowCard = async (slug: string): Promise<Response<Card>> => {
  const res = await api.get(`/app-web/cards/${slug}`);
  return res.data;
};

export const ShowPublicCard = async (slug: string): Promise<Response<Card>> => {
  const res = await api.get(`/app-web/cards/public/${slug}`);
  return res.data;
};

export const ListCards = async (
  query: Query,
): Promise<PaginatedResponse<Card> | Response<Card[]>> => {
  const res = await api.get('/app-web/cards', { params: query });
  return res.data;
};

export const CreateCard = async (
  user_id: number,
  accessory_uuid?: string,
): Promise<Response<Card>> => {
  const res = await api.post('/app-web/cards', { user_id, accessory_uuid });
  return res.data;
};

export const LinkAccessoryToCard = async (
  accessory_uuid: string,
  slug: string,
): Promise<Response<Card>> => {
  const res = await api.post(`/app-web/cards/${slug}/link-accessory`, {
    accessory_uuid,
  });
  return res.data;
};

export const UpdateCard = async (
  slug: string,
  data: Card,
): Promise<Response<Card>> => {
  const res = await api.put(`/app-web/cards/${slug}`, data);
  return res.data;
};

export const DeleteCardImage = async (
  slug: string,
  type: 'avatar' | 'company_logo' | 'cover',
): Promise<Response<Card>> => {
  const res = await api.delete(`/app-web/cards/${slug}/image`, {
    params: { type },
  });
  return res.data;
};

export const UpdateCardImage = async (
  slug: string,
  type: 'avatar' | 'company_logo' | 'cover',
  image: string,
): Promise<Response<Card>> => {
  const res = await api.put(`/app-web/cards/${slug}/image`, { image, type });
  return res.data;
};

export const UpdateCardLinks = async (
  slug: string,
  links: CardLink[],
): Promise<Response<Card>> => {
  const res = await api.put(`/app-web/cards/${slug}/links`, { links });
  return res.data;
};

export const CreateCardLink = async (
  slug: string,
  values: CardLinkFormValues,
  isCustomLink: boolean,
): Promise<Response<Card>> => {
  const res = await api.post(`/app-web/cards/${slug}/link`, {
    ...values,
    type: isCustomLink ? 'custom_link' : 'link',
  });
  return res.data;
};

export const UpdateCardQrCodeColor = async (
  slug: string,
  qr_code_color: string,
): Promise<Response<Card>> => {
  const res = await api.put(`/app-web/cards/${slug}/qr-code-color`, {
    qr_code_color,
  });
  return res.data;
};

export const DeleteCard = async (slug: string): Promise<Response<Card>> => {
  const res = await api.delete(`/app-web/cards/${slug}`);
  return res.data;
};

export const listFollowUpAttachments = async (cardId: number) => {
  const res = await api.get(`/app-web/follow-up-mail/attachments/${cardId}`);
  return res.data;
};

export const uploadFollowUpAttachment = async (cardId: number, file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  const res = await api.post(
    `/app-web/follow-up-mail/attachment/${cardId}`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    },
  );
  return res.data;
};

export const deleteFollowUpAttachment = async (
  cardId: number,
  filename: string,
) => {
  const res = await api.delete(
    `/app-web/follow-up-mail/attachment/${cardId}/${encodeURIComponent(filename)}`,
  );
  return res.data;
};

export const testFollowUpMail = async (cardId: number, email: string) => {
  const res = await api.post(`/app-web/follow-up-mail/test`, {
    card_id: cardId,
    email,
  });
  return res.data;
};
